import * as React from 'react';
import { connect } from 'react-redux';
import {
  IAdhocNotification,
  IAdhocNotificationSaveRequest,
} from '../business-objects/common';
import {
  INotificationTemplate,
  INotificationType,
  INotificationTemplateHeader,
  INotificationTemplateSignature,
} from '../../NotificationTemplate/business-objects/common';
import { Col, Row, Container, Form, Button } from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
  convertToRaw,
  EditorState,
  Modifier,
  RichUtils,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import * as _ from 'lodash';
import NotificationTokens from '../../NotificationTokens/NotificationTokens';
import { getAllTemplates } from '../../NotificationTemplate/redux-objects/actions';
import { cacheAdhocNotification } from '../redux-objects/actions';
import * as urls from '../../shared/urls';

const $ = require('jquery');

interface IAdhocNotificationFormState {
  headerTemplates: INotificationTemplateHeader[];
  signatureTemplates: INotificationTemplateSignature[];
  notificationTypes: INotificationType[];
  notificationTemplates: INotificationTemplate[];
  webServiceURL: string;
  getAllTemplates: (url: string) => void;
  cacheAdhocNotification: (notification: IAdhocNotification) => void;
}

interface IAdhocNotificationFormOwnProps {
  templateToEdit: INotificationTemplate;
}

interface IAdhocNotificationFormLocalState {
  [key: string]: EditorState;
  editorRef: any;
  adhocNotification: IAdhocNotification;
  headerStatus: eTemplateHeaderSignatureStatus;
  signatureStatus: eTemplateHeaderSignatureStatus;
}

enum eTemplateHeaderSignatureStatus {
  NoTemplate = 1,
  UseExisting,
  CreateNew,
}

enum eNotificationType {
  Email = 1,
  Postal,
  Both,
}

enum ServiceEndPoints {
  ActiveTemplates = 'Active',
}
interface IAdhocNotificationFormProps
  extends IAdhocNotificationFormOwnProps,
    IAdhocNotificationFormState {}

export class AdhocNotificationForm extends React.Component<
  IAdhocNotificationFormProps,
  IAdhocNotificationFormLocalState
> {
  constructor(props) {
    super(props);
    this.state = {
      adhocNotification: null,
      editorRef: null,
      headerStatus: eTemplateHeaderSignatureStatus.NoTemplate,
      signatureStatus: eTemplateHeaderSignatureStatus.NoTemplate,
    };
  }
  private notificationTemplateController: string = 'NotificationTemplate';
  componentWillMount() {
    let uri = urls.GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES;

    let params = {
      userOnly: this.state.userOnlyFiler,
      active: true,
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;

    this.props.getAllTemplates(uri);
    if (
      !this.state.adhocNotification &&
      this.props.notificationTemplates.length > 0
    ) {
      this.setSelectedTemplate(this.props.notificationTemplates[0].id);
    }
  }

  componentDidUpdate() {
    if (
      !this.state.adhocNotification &&
      this.props.notificationTemplates.length > 0
    ) {
      this.setSelectedTemplate(this.props.notificationTemplates[0].id);
    }
  }

  setSelectedTemplate = (id) => {
    const selectedTemplate = this.props.notificationTemplates.find(
      (item) => item.id == id
    );
    this.setState(
      {
        adhocNotification: selectedTemplate,
        headerStatus: selectedTemplate.notificationTemplateHeader
          ? eTemplateHeaderSignatureStatus.UseExisting
          : eTemplateHeaderSignatureStatus.NoTemplate,
        signatureStatus: selectedTemplate.notificationTemplateSignature
          ? eTemplateHeaderSignatureStatus.UseExisting
          : eTemplateHeaderSignatureStatus.NoTemplate,
      },
      () => {
        this.updateCache();
      }
    );
  };

  handleTemplateChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'template':
        this.setSelectedTemplate(el.value);
        break;
      case 'subject':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              subject: el.value,
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'description':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              description: el.value,
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'template name':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              name: el.value,
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'notification type':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationType: this.props.notificationTypes.find(
                (item) => item.id == parseInt(el.value)
              ),
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'send from':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              sendFrom: el.value,
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'send to':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              sendTo: el.value,
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'selected header':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateHeader: this.props.headerTemplates.find(
                (item) => item.id == parseInt(el.value)
              ),
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'header name':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateHeader: {
                ...this.state.adhocNotification.notificationTemplateHeader,
                name: el.value,
              },
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'header description':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateHeader: {
                ...this.state.adhocNotification.notificationTemplateHeader,
                description: el.value,
              },
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'selected signature':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateSignature: this.props.signatureTemplates.find(
                (item) => item.id == parseInt(el.value)
              ),
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'signature name':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateSignature: {
                ...this.state.adhocNotification.notificationTemplateSignature,
                name: el.value,
              },
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'signature description':
        this.setState(
          {
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateSignature: {
                ...this.state.adhocNotification.notificationTemplateSignature,
                description: el.value,
              },
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'header no template':
        this.setState(
          {
            headerStatus: eTemplateHeaderSignatureStatus.NoTemplate,
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateHeader: null,
            },
            headerEditorState: EditorState.createEmpty(),
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'header use template':
        this.setState(
          {
            headerStatus: eTemplateHeaderSignatureStatus.UseExisting,
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateHeader: this.props.headerTemplates.find(
                (item) => item.id == 1
              ),
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'header new template':
        this.setState(
          {
            headerStatus: eTemplateHeaderSignatureStatus.CreateNew,
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateHeader: {
                ...({} as INotificationTemplateHeader),
                clientId: 2,
              },
            },
            headerEditorState: EditorState.createEmpty(),
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'signature no template':
        this.setState(
          {
            signatureStatus: eTemplateHeaderSignatureStatus.NoTemplate,
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateSignature: null,
            },
            signatureEditorState: EditorState.createEmpty(),
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'signature use template':
        this.setState(
          {
            signatureStatus: eTemplateHeaderSignatureStatus.UseExisting,
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateSignature: this.props.signatureTemplates.find(
                (item) => item.id == 1
              ),
            },
          },
          () => {
            this.updateCache();
          }
        );
        break;
      case 'signature new template':
        this.setState(
          {
            signatureStatus: eTemplateHeaderSignatureStatus.CreateNew,
            adhocNotification: {
              ...this.state.adhocNotification,
              notificationTemplateSignature: {
                ...({} as INotificationTemplateSignature),
                clientId: 2,
              },
            },
            signatureEditorState: EditorState.createEmpty(),
          },
          () => {
            this.updateCache();
          }
        );
        break;
      default:
        break;
    }
  };

  updateCache = () => {
    this.props.cacheAdhocNotification(this.state.adhocNotification);
  };

  getEditorStateFromHTML = (htmlString: string) => {
    const blocksFromHTML = convertFromHTML(htmlString);
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      )
    );
  };

  onBodyEditorStateChange = (editorBodyState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorBodyState.getCurrentContent())
    );
    this.setState(
      {
        editorState: editorBodyState,
        adhocNotification: {
          ...this.state.adhocNotification,
          body: editorHTML,
        },
      },
      () => this.updateCache()
    );
  };

  onDragOver = (e) => {
    e.preventDefault();
  };

  onDrop = (e, field, type, controlId) => {
    const tagName = '#' + e.dataTransfer.getData('tagName') + '#';

    if (type === 'editor') {
      switch (field) {
        case 'body':
          let bodState = this.getEditorStateFromHTML(
            (this.state.adhocNotification.body || '') + tagName
          );
          this.onBodyEditorStateChange(bodState);
          break;
        case 'signature':
          let sigState = this.getEditorStateFromHTML(
            (this.state.adhocNotification.notificationTemplateSignature
              .content || '') + tagName
          );
          this.onSignatureEditorStateChange(sigState);
          break;
        case 'header':
          let headState = this.getEditorStateFromHTML(
            (this.state.adhocNotification.notificationTemplateHeader.content ||
              '') + tagName
          );
          this.onHeaderEditorStateChange(headState);
          break;
      }
    } else if (type === 'textbox') {
      const index = $('#' + controlId).prop('selectionStart');
      const curValue = this.state.adhocNotification[field] || '';
      const newValue =
        curValue.slice(0, index) + tagName + curValue.slice(index + 1);
      this.setState(
        {
          adhocNotification: {
            ...this.state.adhocNotification,
            [field]: newValue,
          },
        },
        () => this.updateCache()
      );
    }
  };

  onHeaderEditorStateChange = (editorHeaderState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorHeaderState.getCurrentContent())
    );
    this.setState(
      {
        headerEditorState: editorHeaderState,
        adhocNotification: {
          ...this.state.adhocNotification,
          notificationTemplateHeader: {
            ...this.state.adhocNotification.notificationTemplateHeader,
            content: editorHTML,
          },
        },
      },
      () => this.updateCache()
    );
  };

  onSignatureEditorStateChange = (editorSignatureState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorSignatureState.getCurrentContent())
    );
    this.setState(
      {
        signatureEditorState: editorSignatureState,
        adhocNotification: {
          ...this.state.adhocNotification,
          notificationTemplateSignature: {
            ...this.state.adhocNotification.notificationTemplateSignature,
            content: editorHTML,
          },
        },
      },
      () => this.updateCache()
    );
  };

  handleTab = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    let editorDescriptorElement = ((e.currentTarget as HTMLDivElement)
      .children[0] as HTMLDivElement).children[0] as HTMLDivElement;
    let currentState = EditorState.createEmpty();
    let targetStateKey = '';

    if (editorDescriptorElement.dataset.editor == 'eBody')
      targetStateKey = 'editorState';
    else if (editorDescriptorElement.dataset.editor == 'eHeader')
      targetStateKey = 'headerEditorState';
    else targetStateKey = 'signatureEditorState';
    currentState = this.state[targetStateKey];

    const selection = currentState.getSelection();
    const blockType = currentState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    if (
      blockType === 'unordered-list-item' ||
      blockType === 'ordered-list-item'
    ) {
      this.setState({ [targetStateKey]: RichUtils.onTab(e, currentState, 3) });
    } else {
      let newContentState = Modifier.insertText(
        currentState.getCurrentContent(),
        currentState.getSelection(),
        '    '
      );

      this.setState({
        [targetStateKey]: EditorState.push(
          currentState,
          newContentState,
          'insert-characters'
        ),
      });
    }
  };

  render() {
    return (
      <Container>
        <Row className='flex-nowrap'>
          <Col xs={9}>
            <Form>
              <Form.Group controlId='templateType'>
                <Form.Label>
                  <strong>Template</strong>
                </Form.Label>
                <Form.Control
                  as='select'
                  onChange={this.handleTemplateChange}
                  data-field='template'
                  defaultValue={
                    this.state.adhocNotification != null
                      ? this.state.adhocNotification.id
                      : 1
                  }
                >
                  {this.props.notificationTemplates.map((item, idx) => (
                    <option key={idx} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group controlId='templateNotificationType'>
                <Form.Label>
                  <strong>Notification Type</strong>
                </Form.Label>
                <Form.Control
                  as='select'
                  onChange={this.handleTemplateChange}
                  data-field='notification type'
                  value={
                    this.state.adhocNotification != null &&
                    this.state.adhocNotification
                      ? this.state.adhocNotification.notificationType.id.toString()
                      : '1'
                  }
                >
                  {this.props.notificationTypes.map((item, idx) => (
                    <option key={idx} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group controlId='templateSubject'>
                <Form.Label>
                  <strong>Subject</strong>
                </Form.Label>
                <Form.Control
                  type='text'
                  data-field='subject'
                  placeholder='Enter letter template subject...'
                  onChange={this.handleTemplateChange}
                  onDragOver={(e) => this.onDragOver(e)}
                  onDrop={(e) =>
                    this.onDrop(e, 'subject', 'textbox', 'templateSubject')
                  }
                  value={
                    this.state.adhocNotification != null
                      ? this.state.adhocNotification.subject
                      : ''
                  }
                />
              </Form.Group>

              <Form.Group controlId='templateSendFrom'>
                <Form.Label>
                  <strong>Send From</strong>
                </Form.Label>
                <Form.Control
                  type='text'
                  data-field='send from'
                  placeholder='Enter who to send from...'
                  onChange={this.handleTemplateChange}
                  onDragOver={(e) => this.onDragOver(e)}
                  onDrop={(e) =>
                    this.onDrop(e, 'sendFrom', 'textbox', 'templateSendFrom')
                  }
                  value={
                    this.state.adhocNotification != null
                      ? this.state.adhocNotification.sendFrom || ''
                      : ''
                  }
                />
              </Form.Group>

              <Form.Group controlId='templateSendTo'>
                <Form.Label>
                  <strong>Send To</strong>
                </Form.Label>
                <Form.Control
                  as='input'
                  type='text'
                  data-field='send to'
                  placeholder='Enter who to send to...'
                  onChange={this.handleTemplateChange}
                  value={
                    this.state.adhocNotification != null
                      ? this.state.adhocNotification.sendTo || ''
                      : ''
                  }
                  onDragOver={(e) => this.onDragOver(e)}
                  onDrop={(e) =>
                    this.onDrop(e, 'sendTo', 'textbox', 'templateSendTo')
                  }
                />
              </Form.Group>

              <Form.Group controlId='templateHeader'>
                <Form.Label>
                  <strong>Header</strong>
                </Form.Label>
                <fieldset>
                  <Form.Check
                    id='chk-header-none'
                    type='radio'
                    label='No Header'
                    name='templateHeaderRadios'
                    onChange={this.handleTemplateChange}
                    data-field='header no template'
                    checked={
                      this.state.headerStatus ==
                      eTemplateHeaderSignatureStatus.NoTemplate
                    }
                  />
                  <Form.Check
                    id='chk-header-existing'
                    type='radio'
                    label='Use Exisitng Header'
                    name='templateHeaderRadios'
                    data-field='header use template'
                    onChange={this.handleTemplateChange}
                    checked={
                      this.state.headerStatus ==
                      eTemplateHeaderSignatureStatus.UseExisting
                    }
                  />
                  <Form.Check
                    id='chk-header-new'
                    type='radio'
                    label='Create New Header'
                    name='templateHeaderRadios'
                    data-field='header new template'
                    onChange={this.handleTemplateChange}
                    checked={
                      this.state.headerStatus ==
                      eTemplateHeaderSignatureStatus.CreateNew
                    }
                  />
                </fieldset>

                {this.state.headerStatus ==
                  eTemplateHeaderSignatureStatus.UseExisting && (
                  <Form.Control
                    as='select'
                    onChange={this.handleTemplateChange}
                    data-field='selected header'
                    defaultValue={
                      this.state.adhocNotification != null &&
                      this.state.adhocNotification.notificationTemplateHeader !=
                        null
                        ? this.state.adhocNotification
                            .notificationTemplateHeader.id
                        : 1
                    }
                  >
                    {this.props.headerTemplates.map((item, idx) => (
                      <option key={idx} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Control>
                )}

                {this.state.headerStatus ==
                  eTemplateHeaderSignatureStatus.CreateNew && (
                  <React.Fragment>
                    <div
                      onDragOver={(e) => this.onDragOver(e)}
                      onDrop={(e) => this.onDrop(e, 'header', 'editor', '')}
                    >
                      <Form.Label>Header Content</Form.Label>
                      <Editor
                        wrapperClassName='wrapper-class'
                        editorClassName='editor-class'
                        onEditorStateChange={this.onHeaderEditorStateChange}
                        spellCheck={true}
                        onTab={this.handleTab}
                        editorKey='eHeader'
                        editorState={this.state.headerEditorState}
                        placeholder={'Enter header content...'}
                        toolbarHidden={false}
                        toolbar={{ options: ['image', 'remove'] }}
                        data-field='header editor'
                      />
                    </div>
                  </React.Fragment>
                )}
              </Form.Group>

              <Form.Group
                controlId='templateBody'
                onDragOver={(e) => this.onDragOver(e)}
                onDrop={(e) => this.onDrop(e, 'body', 'editor', 'templateBody')}
              >
                <Form.Label>
                  <strong>Body Content</strong>
                </Form.Label>
                <Editor
                  wrapperClassName='wrapper-class'
                  editorClassName='editor-class'
                  onEditorStateChange={this.onBodyEditorStateChange}
                  spellCheck={true}
                  onTab={this.handleTab}
                  editorKey='eBody'
                  editorState={this.state.editorState}
                  placeholder='Enter body content ...'
                  toolbarHidden={false}
                  toolbar={{
                    options: [
                      'inline',
                      'blockType',
                      'fontSize',
                      'fontFamily',
                      'list',
                      'textAlign',
                      'link',
                      'image',
                      'remove',
                      'history',
                    ],
                  }}
                  data-field='body editor'
                  handleDrop={() => 'handled'}
                  //editorRef={this.setEditorReference}
                  // onDragOver={e => this.onDragOver(e)}
                  // onDrop={e => this.onDrop(e, 'body')}
                />
              </Form.Group>

              <Form.Group controlId='templateSignature'>
                <Form.Label>
                  <strong>Signature</strong>
                </Form.Label>
                <fieldset>
                  <Form.Check
                    id='chk-sig-none'
                    type='radio'
                    label='No Signature'
                    name='templateSignatureRadios'
                    data-field='signature no template'
                    onChange={this.handleTemplateChange}
                    checked={
                      this.state.signatureStatus ==
                      eTemplateHeaderSignatureStatus.NoTemplate
                    }
                  />
                  <Form.Check
                    id='chk-sig-existing'
                    type='radio'
                    label='Use Exisitng Signature'
                    name='templateSignatureRadios'
                    data-field='signature use template'
                    onChange={this.handleTemplateChange}
                    checked={
                      this.state.signatureStatus ==
                      eTemplateHeaderSignatureStatus.UseExisting
                    }
                  />
                  <Form.Check
                    id='chk-sig-new'
                    type='radio'
                    label='Create New Signature'
                    name='templateSignatureRadios'
                    data-field='signature new template'
                    onChange={this.handleTemplateChange}
                    checked={
                      this.state.signatureStatus ==
                      eTemplateHeaderSignatureStatus.CreateNew
                    }
                  />
                </fieldset>

                {this.state.signatureStatus ==
                  eTemplateHeaderSignatureStatus.UseExisting && (
                  <Form.Control
                    as='select'
                    onChange={this.handleTemplateChange}
                    data-field='selected signature'
                    defaultValue={
                      this.state.adhocNotification != null &&
                      this.state.adhocNotification
                        .notificationTemplateSignature != null
                        ? this.state.adhocNotification
                            .notificationTemplateSignature.id
                        : 1
                    }
                  >
                    {this.props.signatureTemplates.map((item, idx) => (
                      <option key={idx} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Control>
                )}

                {this.state.signatureStatus ==
                  eTemplateHeaderSignatureStatus.CreateNew && (
                  <React.Fragment>
                    <div
                      onDragOver={(e) => this.onDragOver(e)}
                      onDrop={(e) => this.onDrop(e, 'signature', 'editor', '')}
                    >
                      <Form.Label>Signature Content</Form.Label>
                      <Editor
                        wrapperClassName='wrapper-class'
                        editorClassName='editor-class'
                        onEditorStateChange={this.onSignatureEditorStateChange}
                        spellCheck={true}
                        onTab={this.handleTab}
                        editorKey='eSignature'
                        editorState={this.state.signatureEditorState}
                        placeholder={'Enter signature content...'}
                        toolbarHidden={false}
                        toolbar={{
                          options: [
                            'inline',
                            'blockType',
                            'fontSize',
                            'fontFamily',
                            'list',
                            'textAlign',
                            'link',
                            'image',
                            'remove',
                            'history',
                          ],
                        }}
                        data-field='signature editor'
                      />
                    </div>
                  </React.Fragment>
                )}
              </Form.Group>
            </Form>
          </Col>
          <Col>
            <NotificationTokens />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    headerTemplates: reduxState.NotificationTemplates.headerTemplates,
    signatureTemplates: reduxState.NotificationTemplates.signatureTemplates,
    notificationTypes: reduxState.NotificationTemplates.notificationTypes,
    notificationTemplates: reduxState.NotificationTemplates.allNotifications,
    webServiceURL: reduxState.Application.backendURL,
  };
};

const mapDispatchToProps = {
  getAllTemplates,
  cacheAdhocNotification,
};

export default connect<IAdhocNotificationFormState, any>(
  mapStateToProps,
  mapDispatchToProps
)(AdhocNotificationForm);
